import { render } from "./Employee25Liquidations.vue?vue&type=template&id=248c034e"
import script from "./Employee25Liquidations.vue?vue&type=script&lang=js"
export * from "./Employee25Liquidations.vue?vue&type=script&lang=js"

import "./Employee25Liquidations.vue?vue&type=style&index=0&id=248c034e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__